module.exports = __webpack_public_path__ + "static/brackets-a7b08018400cede678ce36977d98f55e.png";